export default __webpack_public_path__ + "static/media/boyOnTractor.cd86a205.jpg";